/**
 * Test IDs for QA automation.
 */
export const testIds = {
  downloadAppsGooglePlay: "download-apps-google-play",
  downloadAppsAppleAppStore: "download-apps-apple-app-store",
} as const;
